// 根据角色动态生成路由
import { defineFakeRoute } from "vite-plugin-fake-server/client";

export default defineFakeRoute([
  {
    url: "/login",
    method: "post",
    response: ({ body }) => {
      if (body.username === "admin") {
        return {
          success: true,
          data: {
            avatar: "https://avatars.githubusercontent.com/u/44761321",
            username: "admin",
            roles: ["common"],
            permissions: [
              "permission:btn:add",
              "permission:btn:edit",
              "permission:btn:delete"
            ],
            token: "eyJhbGciOiJIUzUxMiJ9.admin",
            expires: "2030/10/30 00:00:00"
          }
        };
      } else {
        return {
          success: true,
          data: {
            avatar: "https://avatars.githubusercontent.com/u/52823142",
            username: "common",
            roles: ["common"],
            permissions: ["permission:btn:delete"],
            token: "eyJhbGciOiJIUzUxMiJ9.common",
            expires: "2030/10/30 00:00:00"
          }
        };
      }
    }
  }
]);
